export default __webpack_public_path__ + "static/9-4651d7d3c3d92c3c69e5bf2f33272d78.png";